var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 10c.8959417 0 1.7668658.1071131 2.600665.3092321-3.3844371 2.3476354-5.600665 6.2603878-5.600665 10.6907679s2.2162279 8.3431325 5.6005281 10.6901016c-.8336623.2027853-1.7045864.3098984-2.6005281.3098984-6.07513225 0-11-4.9248678-11-11s4.92486775-11 11-11zm10 0c6.0751322 0 11 4.9248678 11 11s-4.9248678 11-11 11-11-4.9248678-11-11 4.9248678-11 11-11zm-5-10c5.5338762 0 10.1133202 4.08641041 10.8853932 9.40629265-1.7677089-.89979074-3.7674011-1.40629265-5.8853932-1.40629265-1.7724529 0-3.4620572.35471685-5.0016968.99703443-1.5379833-.64268219-3.2267615-.99703443-4.9983032-.99703443-2.11839115 0-4.11843786.50669281-5.88555685 1.40549516.77223669-5.31908475 5.35168065-9.40549516 10.88555685-9.40549516z",
    fill: "#202327"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHue);
export default __webpack_public_path__ + "static/media/hue.db076ee21c92ecb83476af287c62e07e.svg";
export { ForwardRef as ReactComponent };